import api from './client';

export const getInvoices = () =>
  api.get('/invoices').then(r => r.data);

export const getInvoice = (id) =>
  api.get(`/invoices/${id}`).then(r => r.data);

export const resendInvoiceEmail = (id) =>
  api.post(`/invoices/${id}/email`).then(r => r.data);
